/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { memo } from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './constants.tsx';
import {
	Nav4Recommendations as Nav4RecommendationsWithoutErrorBoundary,
	type Props,
} from './ui/Nav4Recommendations.tsx';

export const Nav4Recommendations: React.NamedExoticComponent<Props> =
	memo<Props>(RecommendationsQuery);

function RecommendationsQuery(props: Props = {}): React.JSX.Element {
	return (
		<JSErrorBoundary
			id="growth-recommendations"
			fallback="unmount"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<Placeholder name="recommendations">
				<Nav4RecommendationsWithoutErrorBoundary {...(props || {})} />
			</Placeholder>
		</JSErrorBoundary>
	);
}
